import React from 'react';
import { Alert } from 'antd';

import { get } from '../../../../../../shared/helpers';
import { checkValuationExpired } from '../../../../utils/checkValuationExpired';

const RevaluationAlert = ({ lastValuationDate, leadMarketing }) => {
    const lead_division_id = get(leadMarketing, 'ref_lead_source._id');

    const { hasExpired, days } = checkValuationExpired({ divisionId: lead_division_id, lastValuationDate });

    return hasExpired
        ? (
            <>
                <Alert
                    style={{ marginBottom: 10, borderRadius: 5, fontSize: 16 }}
                    message="Revalue Bike"
                    description={`This bike requires a re-valuation as the last valuation is greater than ${days} days old`}
                    type="warning"
                    showIcon
                />
            </>
        )
        : null;
};

export default RevaluationAlert;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/Alerts/RevaluationAlert.js